import { hasFlag } from 'country-flag-icons'
import * as flagStrings from 'country-flag-icons/string/3x2'
import { unescape } from 'es-toolkit'

/** Returns the flag image data URL that matches the country code. Returns `null` if no flag was found. */
export const getCountryFlagImageUrl = (countryCode: string) => {
	const upperCasedCode = countryCode.toUpperCase()
	if (!hasFlag(upperCasedCode) || !flagStrings[upperCasedCode as keyof typeof flagStrings]) {
		console.warn(`Flag: ${upperCasedCode} not found`)
		return null
	}

	return `data:image/svg+xml;base64,${btoa(unescape(flagStrings[upperCasedCode as keyof typeof flagStrings]))}`
}
